<template>
  <page-layout class="crm-page-layout">
    <router-view></router-view>
  </page-layout>
</template>

<script>
import PageLayout from './pageLayout.vue'

export default {
  components: {
    PageLayout
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {
    if (!this.hasAnyPermission({
      strict: false,
      isMatchAnd: true,
      any: [
        ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
        ['PERM_CANDIDATE_SURVEY_MANAGEMENT', 'PREMIUM_PREFERENCE_SURVEY_MANAGEMENT'],
        ['PERM_TAG_MANAGEMANT', 'PREMIUM_TAG_MANAGEMENT']
      ]
    })) {
      this.$router.push('error/no-permission')
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.crm-page-layout {
  height: 100%;
  font-size: 14px;
  line-height: 20px;
  color: #909399;
}
</style>
